export const pxToRem = (px: number): string => {
  return `${(px * 16) / 375}rem`;
};
